module.exports = "/_next/static/images/679ef1ecd2d2439bcf7e836b6d5e047d-moneyboxes-right.jpg";